import React from "react";
import styles from "./ProfileDetailPage.module.css";
import ProfileStatus from "../ProfileStatus";

function HeightDisplay({ cm }) {
  const isValid = cm !== null && cm !== undefined && cm !== "";
  const feet = isValid ? (cm / 30.48).toFixed(1) : null;

  return (
    <p>
      <strong>Height:</strong> {isValid ? `${cm}cm (${feet} ft)` : ""}
    </p>
  );
}

export default function HeaderDetails({ profile }) {
  if (!profile) return null;

  return (
    <div className={styles.headerDetails}>
      <div className={styles.statsBlock}>
        <h1 className={styles.profileName}>{profile.name}</h1>

        <ProfileStatus profile={profile} />
        {profile.highlights && (
          <p className={styles.highlightLine}>
            <strong>Highlights:</strong> {profile.highlights}
          </p>
        )}
        <p>
          <strong>Ethnicity:</strong> {profile.ethnicity}
        </p>
        {profile?.heightCm && <HeightDisplay cm={profile.heightCm} />}
        {profile.braSize && (
          <p>
            <strong>Bra Size:</strong> {profile.braSize}
          </p>
        )}
      </div>
    </div>
  );
}
